import { Folder } from "@livechat/design-system-icons";

import { ticketDetailedSourcesLabel } from "helpers/tickets";
import { DetailedSource } from "interfaces/entities/ticket";

import { IFilterConfig, IFilterLabelValue } from "../interfaces";

export const ticketSourceFilterConfig: IFilterConfig = {
  title: "Source",
  icon: Folder,
  multiple: true,
  getFilterLabelValues: (filterValues: DetailedSource[] | null): IFilterLabelValue[] => {
    if (filterValues === null) {
      return [];
    }

    return filterValues.map((filterValue: keyof typeof ticketDetailedSourcesLabel) => ({
      key: filterValue,
      label: ticketDetailedSourcesLabel[filterValue],
    }));
  },
};
